import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['display', 'display-xl'],
    },
  },
})

export function cn(...args: ClassValue[]) {
  return twMerge(clsx(args))
}
